import { useState } from "react";
import "./index.scss";
import Chevron from "icons/Chevron";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";

type AccordianItemProps = {
  title: string;
  description: string;
  className?: string;
  index: number;
  addDivider?: boolean;
  dividerClassname?: string;
  isLastItem?: boolean;
  isPlusCategories?: boolean;
};

const AccordionV2Item = ({
  title,
  description,
  className,
  index,
  addDivider = true,
  dividerClassname = "",
  isLastItem = false,
  isPlusCategories,
}: AccordianItemProps): JSX.Element => {
  const [isDescriptionOpen, setisDescriptionOpen] = useState(false);

  const handleTitleClick = () => {
    setisDescriptionOpen(!isDescriptionOpen);
  };

  return (
    <div
      className={`${className} ${isDescriptionOpen ? "accordion-item active" : "accordion-item"}`}
      key={index}
    >
      <div
        className="accordion-header"
        onClick={handleTitleClick}
        onKeyDown={handleTitleClick}
        role="none"
      >
        {title}
        <div className={isDescriptionOpen ? "chevron active" : "chevron"}>
          <Chevron />
        </div>
      </div>
      {typeof description === "string" ? (
        <div
          className="accordion-content"
          dangerouslySetInnerHTML={{ __html: replaceAmberDomainInLinks(description) }}
        />
      ) : (
        <div className="accordion-content">{description}</div>
      )}

      {isPlusCategories ? (
        <>
          {addDivider && !isLastItem && (
            <div className={formatClassNames(dividerClassname, "accordion-devider")} />
          )}
        </>
      ) : (
        <>
          {addDivider && (
            <div className={formatClassNames(dividerClassname, "accordion-devider")} />
          )}
        </>
      )}
    </div>
  );
};

export default wrapperHOC(AccordionV2Item, {
  componentName: "AccordionV2Item-Global",
  showForChina: true,
});
